export default {
  whoWeAre: "我们是谁",
  whoWeAreDescription: "一个领先的制药平台，拥有40多年的API卓越经验，在高级中间体方面拥有全球合作伙伴关系，并在专业配方和抗生素方面拥有CRDMO专业知识。",
  globalImpactExcellence: "全球影响与卓越",
  globalImpactDescription: "受到全球合作伙伴的信任，通过科学提供有意义的创新。",
  whatWeOffer: "我们提供的服务",
  whatWeOfferDescription: "全面的制药解决方案，拥有数十年的专业知识和全球影响力，在多样化的治疗领域从实验室到生活提供创新。",
  regulatoryApprovals: "监管批准",
  regulatoryApprovalsDescription: "Refex Life Sciences运营着一个全球最先进的制造设施网络，无缝集成到集团中。这些设施符合最高的国际质量标准，并获得以下认证：",
  regulatoryApproval1: "美国FDA",
  regulatoryApproval2: "欧盟GMP",
  regulatoryApproval3: "EDQM",
  regulatoryApproval4: "加拿大卫生部",
  regulatoryApproval5: "ANVISA",
  regulatoryApproval6: "PMDA",
  regulatoryApproval7: "WHO-GMP",
  noOfferingsAvailable: "没有可用的服务。请在管理面板中添加一些。",
};

